import React from 'react';
import PropTypes from 'prop-types';
import Slider from '@material-ui/core/Slider';

import styles from './Controls.css';


const ControlsWrapper = (props) => {
  const {
    controlsClasses,
    leftComponent,
    rightComponent,
    seekValue,
    showSeekBar,
    onSeekChange,
  } = props;

  return (
    <div className={controlsClasses}>
      {showSeekBar && (
        <div className="Controls_seek">
          <Slider
            aria-labelledby="seek-slider"
            className="Controls_seek_slider"
            value={seekValue}
            onChange={onSeekChange}
          />
        </div>
      )}
      <div className={styles.container}>
        <div className={styles.left}>
          {leftComponent}
        </div>
        <div className={styles.right}>
          {rightComponent}
        </div>
      </div>
    </div>
  );
};

ControlsWrapper.propTypes = {
  controlsClasses: PropTypes.string,
  leftComponent: PropTypes.object,
  rightComponent: PropTypes.object,
  seekValue: PropTypes.number,
  showSeekBar: PropTypes.bool,
  onSeekChange: PropTypes.func,
};

ControlsWrapper.defaultProps = {
  controlsClasses: undefined,
  leftComponent: null,
  rightComponent: null,
  seekValue: undefined,
  showSeekBar: false,
  onSeekChange: () => undefined,
};

export default ControlsWrapper;
